import { ReactElement, useCallback } from 'react';
import { AxiosResultDefaultError } from '../../../../../../api/request';
import { createFetchContext } from '../../../../../../components/contexts/FetchContextFactory';
import { getTeacherInfo } from '../../EducationalBackground/api';
import { TeacherInfoResponse } from '../type';

interface BaseLoaderProps {
  teacherId: number;
  children: ReactElement;
}

const { FetchProvider, FetchConsumer, useFetch } = createFetchContext<
  undefined,
  TeacherInfoResponse,
  AxiosResultDefaultError
>();

// Cache para no volver a cargar la información del profesor cuando se cambia de pestaña
const responseCache: Record<number, TeacherInfoResponse> = {};

export function useTeacherInfoLoader() {
  return useFetch();
}

export const TeacherInfoLoaderConsumer = FetchConsumer;

export default function TeacherInfoLoader({
  teacherId,
  children,
}: BaseLoaderProps) {
  const request = useCallback(async () => {
    // Verifica caché
    if (responseCache[teacherId]) {
      return { data: responseCache[teacherId], status: 200 };
    }

    // Si no está en caché, hace la petición, y guarda
    const response = await getTeacherInfo(teacherId);
    if (response.data) {
      responseCache[teacherId] = response.data;
    }
    return response;
  }, [teacherId]);

  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      {children}
    </FetchProvider>
  );
}
